import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={11 * (props.wx ?? 1)}
    height={26 * (props.hx ?? 1)}
    viewBox="0 0 11 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M1.65117 7.53698C1.69634 7.83106 1.77189 8.44262 2.04036 9.00443C2.30248 9.55249 2.55574 9.73381 2.64692 10.3231C3.14079 13.5053 3.0378 14.0145 4.07914 17.8231C4.77182 20.357 5.48506 25.2343 5.9726 25.3231C6.51374 25.4215 6.91857 20.6355 6.9726 17.8231C7.4726 13.9841 8.59627 12.8596 8.78664 10.4185C8.87612 9.26818 8.8759 9.02188 8.97256 8.71777C9.0553 8.4571 9.44725 8.15857 9.48144 7.81881C9.59667 6.68035 9.57091 4.3663 9.47256 2.77483C9.41516 1.84319 9.27798 1.46185 8.52958 1.40096C6.91713 1.26988 3.52491 1.30924 2.07876 1.48153C1.55746 1.54354 1.51187 1.87995 1.49752 2.49523C1.46333 3.99424 1.42957 6.09664 1.65117 7.53698Z"
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgNormal;
